import styled from 'styled-components'
import { ContentHeader } from '../../../App'
import { useContext } from 'react'
import { OrderDataContext } from "../Context/WaiterContext"

function Fourth ({ setPage }) {
    return (
        <Wrapper>
            <ContentHeader>
                <h1>Thank you!</h1>
                <p>
                    Your order has been successfully sent to the kitchen.
                </p>
                <Button onClick={() => setPage('first')}>Create new order</Button>

            </ContentHeader>
        </Wrapper>
    )
}

const Button = styled.button`
    border: 0;
    padding: 10px;
    background-color: #AE996F;
    color: #fff;
    border-radius: 10px;
    width: 100%;
    max-width: 300px;
    font-size: 18px;
    cursor: pointer;
    margin-top: 15px;
    &:hover {
        opacity: 0.8;
    }
`
export { Button }

const Wrapper = styled.div`
    flex: 1;
    flex-direction: column;
    justify-content: center;

    h1 {
        font-size: 50px !important;
        font-weight: 300 !important;
    }
`

export default Fourth
